const NAVIGATION_APP_URLS = {
  b2b: {
    uat: 'https://staging-corporategifts.1800flowers.com/',
    production: 'https://corporategifts.1800flowers.com/'
  },
  bulkGifting: {
    uat: 'https://staging-corporategifts.1800flowers.com/bulk-gifting/recipient',
    production: 'https://corporategifts.1800flowers.com/bulk-gifting/recipient'
  }
};

export { NAVIGATION_APP_URLS };
